import React, { useEffect, useState } from 'react';
import { SxProps } from '@mui/material';

import AutoCompleteDropdown, { AutoCompleteOption } from '../../AutoCompleteDropdown';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { selectEvent, getAircraftListThunk } from '../../../../slices/eventSlice';

interface AircraftTypeProps {
    label: string;
    defaultValue?: string;
    value?: string | AutoCompleteOption;
    sx?: SxProps;
    onChange?: (option: AutoCompleteOption) => void;
    isDisabled?: boolean;
}

const AircraftType = (props: AircraftTypeProps) => {
    const { label, defaultValue, sx, value, onChange, isDisabled } = props;

    const dispatch = useAppDispatch();
    const { aircraftOptions } = useAppSelector(selectEvent);
    const [selectedValue, setSelectedValue] = useState<AutoCompleteOption>();

    const filterOptions = (
        options: AutoCompleteOption[],
        { inputValue }: { inputValue: any }
    ): AutoCompleteOption[] => {
        const searchKey = inputValue.toUpperCase();
        return options.filter((option: AutoCompleteOption, index: number, self: AutoCompleteOption[]) => {
            if (!option || self.indexOf(option) !== index) {
                return false;
            }
            return option.value.match(searchKey) !== null;
        });
    };

    useEffect(() => {
        if (Array.isArray(aircraftOptions) && !selectedValue && defaultValue) {
            const defaultOption = aircraftOptions.find((item) => item.value === defaultValue);
            setSelectedValue(defaultOption);
        }
    }, [aircraftOptions]);

    useEffect(() => {
        if (!value) setSelectedValue(null);

        if (typeof value === 'string' && value !== selectedValue?.value)
            setSelectedValue(aircraftOptions.find((item) => item.value === value) || null);

        if ((value as AutoCompleteOption)?.value !== selectedValue?.value)
            setSelectedValue(value as AutoCompleteOption);
    }, [value, aircraftOptions]);

    useEffect(() => {
        if (!aircraftOptions || aircraftOptions.length <= 0) {
            dispatch(getAircraftListThunk());
        }
    }, []);

    return (
        <AutoCompleteDropdown
            label={label}
            options={aircraftOptions}
            value={value}
            sx={sx}
            filterOptions={filterOptions}
            onChange={(option) => {
                if (option) {
                    setSelectedValue(option);
                    onChange?.(option);
                }
            }}
            isDisabled={isDisabled}
        />
    );
};

export default AircraftType;
